import { handleActions } from "redux-actions";

import {
  SET_LOADING,
  SET_STATUS,
  RESET_STATUS,
  SET_ERROR,
  FETCH_SETTINGS_SUCCESS,
  FETCH_USERS_SUCCESS,
  SET_UPDATE_LOADING,
  SET_ACTIONS_LOADING,
  FETCH_ACTIONS_SUCCESS,
  DELETE_USER_SUCCESS,
  DUPLICATE_USER_SUCCESS,
  EDIT_USER_SUCCESS,
  FETCH_USER_INFO_SUCCESS,
  MIRROR_USER_SUCCESS,
  FETCH_EMAILS_SUCCESS,
  SET_ADMIN_SUCCESS
} from "./usersSagas";
import sortBy from "lodash/sortBy";

export const initialState = {
  isLoading: true,
  areUsersLoading: false,
  actionsLoading: true,
  status: "idle",
  errors: null,
  users: null,
  commonSettings: { roles: [], locations: [], permissions: [] },
  currentEmailInfo: null,
  currentUserActions: {},
  currentSearchParam: null
};

export default handleActions(
  {
    [SET_ERROR]: (state, action) => ({
      ...state,
      status: "failed",
      errors: action.payload
    }),
    [SET_STATUS]: (state, action) => ({
      ...state,
      status: action.payload
    }),
    [RESET_STATUS]: (state) => ({
      ...state,
      status: "idle",
      errors: null,
      currentUserInfo: null
    }),
    [SET_LOADING]: (state, action) => ({
      ...state,
      isLoading: action.payload
    }),
    [SET_UPDATE_LOADING]: (state, action) => ({
      ...state,
      areUsersLoading: action.payload
    }),
    [SET_ACTIONS_LOADING]: (state, action) => ({
      ...state,
      actionsLoading: action.payload
    }),
    [FETCH_SETTINGS_SUCCESS]: (state, action) => ({
      ...state,
      commonSettings: action.payload
    }),
    [FETCH_USERS_SUCCESS]: (state, { payload: { users, searchParam } }) => ({
      ...state,
      users,
      currentSearchParam: searchParam ? searchParam : state.currentSearchParam
    }),
    [FETCH_EMAILS_SUCCESS]: (state, action) => ({
      ...state,
      currentEmailInfo: action.payload
    }),
    [FETCH_ACTIONS_SUCCESS]: (state, action) => ({
      ...state,
      currentUserActions: action.payload
    }),
    [FETCH_USER_INFO_SUCCESS]: (state, action) => ({
      ...state,
      currentUserInfo: action.payload
    }),
    [DUPLICATE_USER_SUCCESS]: (state, { payload: { data, orgName } }) => {
      return {
        ...state,
        users: { ...state.users, [orgName]: sortByName([...state.users[orgName], data]) }
      };
    },
    [EDIT_USER_SUCCESS]: (state, { payload: { id, data, orgName, organizationId } }) => {
      return {
        ...state,
        status: "success",
        users: {
          ...state.users,
          ...getEditedUsers({
            oldOrgId: organizationId,
            newOrgId: data.organizationId,
            orgName,
            users: state.users,
            userId: id,
            data,
            organizations: state.commonSettings.filters.organizations
          })
        }
      };
    },
    [SET_ADMIN_SUCCESS]: (state, { payload: { id, data, orgName } }) => {
      return {
        ...state,
        status: "success",
        users: {
          ...state.users,
          "No Organization": sortByName([...state.users["No Organization"], data]),
          [orgName]: state.users[orgName].filter((user) => user.id !== id)
        }
      };
    },
    [MIRROR_USER_SUCCESS]: (state, { payload: { data, orgName } }) => {
      return {
        ...state,
        users: {
          ...state.users,
          [orgName]: state.users[orgName].map((user) => {
            let foundUser = data.find((val) => val.id === user.id);

            return foundUser ? foundUser : user;
          })
        }
      };
    },
    [DELETE_USER_SUCCESS]: (state, { payload: { id, orgName } }) => ({
      ...state,
      users: state.users[orgName].map((user) =>
        user.id == id ? { ...user, isDeleted: true } : user
      )
    })
  },

  initialState
);

const sortByName = (arr) => {
  return sortBy(arr, [
    (user) => user.lastName.toLowerCase(),
    (user) => user.firstName.toLowerCase()
  ]);
};

const getEditedUsers = ({ oldOrgId, newOrgId, orgName, users, userId, data, organizations }) => {
  if (!oldOrgId || oldOrgId === newOrgId) {
    return {
      [orgName]: sortByName(users[orgName].map((user) => (user.id == userId ? data : user)))
    };
  }

  if (oldOrgId !== newOrgId) {
    let newOrgName = organizations.find((org) => org.id === newOrgId).name;
    return {
      [orgName]: sortByName(users[orgName].filter((user) => user.id !== userId)),
      [newOrgName]: sortByName([...(users[newOrgName] ?? []), data])
    };
  }
};
